import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from '@services/role.guard';
import { AdminOrdersComponent } from '@components/orders/orders.component';
import { AdminPackagesRulesComponent } from '@components/packages-rules/packages-rules.component';
import { PriceRulesComponent } from '@components/price-rules/price-rules.component';
import { AdminServicesDeliveryComponent } from '@components/services-delivery/services-delivery.component';
import { AdminServicesModesComponent } from '@components/services-modes/services-modes.component';
import { CompaniesComponent } from '@components/companies/companies.component';
import { AdminSettingsComponent } from '@components/admin-settings/admin-settings.component';

const routes: Routes = [
  {path: '', redirectTo: 'admin', pathMatch: 'full'},
  {
    path: 'admin', children: [
      {path: '', redirectTo: 'orders', pathMatch: 'full'},
      {path: 'settings', component: AdminSettingsComponent},
      {path: 'orders', component: AdminOrdersComponent},
      {path: 'packages-rules', component: AdminPackagesRulesComponent},
      {path: 'price-rules', component: PriceRulesComponent},
      {path: 'services-delivery', component: AdminServicesDeliveryComponent},
      {path: 'services-modes', component: AdminServicesModesComponent},
      {path: 'companies', component: CompaniesComponent}
    ],
    canActivate: [RoleGuard], data: {expectedRole: '5'}
  },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class RoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts